import { render } from "./InterfaceButton.vue?vue&type=template&id=dad36352&scoped=true"
import script from "./InterfaceButton.vue?vue&type=script&lang=js"
export * from "./InterfaceButton.vue?vue&type=script&lang=js"

import "./InterfaceButton.vue?vue&type=style&index=0&id=dad36352&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad36352"]])

export default __exports__